export const STYLE_FIELD_NAME = "style";
